import React, { useEffect, useState } from "react";

import { Box } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import MuiToggleButtonGroup from "@mui/material/ToggleButtonGroup";

type Props = {
  exclusive: boolean;
  loading?: boolean;
  onChange: Function;
  options: { value: any; label: string }[];
  orientation: "horizontal" | "vertical" | undefined;
  value: any;
  size: "small" | "medium" | "large" | undefined;
  disabled: boolean;
  customSelector?: React.ReactNode | null;
};

function ToggleButtonGroup({
  exclusive,
  loading: loadingFromArgs,
  onChange,
  options,
  orientation,
  value,
  size,
  disabled,
  customSelector = null,
}: Props): JSX.Element {
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [loading, setLoading] = useState(loadingFromArgs);

  useEffect(() => {
    setLoading(!!loadingFromArgs);
  }, [loadingFromArgs]);

  async function handleChange(...args: any) {
    if (loading) return null;

    setRequestInProgress(true);
    await onChange(...args);
    setRequestInProgress(false);
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <MuiToggleButtonGroup
        size={size}
        value={value}
        exclusive={exclusive}
        onChange={handleChange}
        orientation={orientation}
        aria-label="text alignment"
        disabled={disabled}
      >
        {options.map(
          (option): JSX.Element => (
            <ToggleButton
              disabled={requestInProgress || loading || disabled}
              key={option?.value}
              value={option?.value}
              aria-label={option?.label}
            >
              {option?.label}
            </ToggleButton>
          )
        )}
      </MuiToggleButtonGroup>
      {customSelector && (
        <Box
          sx={{
            width: "100%",
            marginLeft: "40px",
          }}
        >
          {customSelector}
        </Box>
      )}
    </Box>
  );
}

ToggleButtonGroup.defaultProps = {
  exclusive: false,
  size: "small",
  orientation: "horizontal",
};

export default ToggleButtonGroup;
